import { useContext } from 'react';
import { SubdivisionContext } from 'common/context/subdivision/subdivision.context';

export const useSubdivisionContext = () => useContext(SubdivisionContext);
